import { Box } from "@mui/material";
import { Fragment, memo, useEffect, useRef, useState } from "react";
import { Options } from "./Options";
import ManualCropUsingCdn from "./components/ManualCropUsingCdn";
import { DamContentGallery } from "./components/damContentGallery/DamContentGallery";
import "./x-image-render.css";

const XImageRenderWithText = ({
  callBack,
  editData,
  isCrop = true,
  name = "",
  items,
  setItems,
  variant = "",
  validations = [],
  placeholder = "",
}) => {
  const currentItem = useRef(0);
  const [returnData, setReturnData] = useState(editData);
  const [manualCropShow, setManualCropShow] = useState(false);
  const [galleryDialogOpen, setGalleryDialogOpen] = useState(false);

  const handleSelectedImage = (selectedAsset) => {
    const payload = {
      original_image: selectedAsset || {},
      published_images: [],
    };
    setReturnData(payload);
    toggleGallery(false, "done");
    if (name) callBack(payload, currentItem.current);
    else callBack(payload);
  };

  const toggleGallery = (toggleState: boolean, _type: string) => {
    setGalleryDialogOpen(toggleState);
  };

  const showGallery = (id) => {
    window.scrollTo(0, 0);
    currentItem.current = id;
    setGalleryDialogOpen(true);
  };

  const backTo = () => {
    if (manualCropShow) setManualCropShow(false);
  };

  const doneCropCompleted = (cropHints: any[] = []) => {
    const data = {
      ...returnData,
      published_images: cropHints,
    };
    setReturnData(data);
    if (name) callBack(data, currentItem.current);
    else callBack(data);
    setManualCropShow(false);
  };

  const changeCrop = (id) => {
    currentItem.current = id;
    setManualCropShow(true);
  };

  useEffect(() => {
    if (editData && JSON.stringify(editData) !== JSON.stringify(returnData)) {
      setReturnData(editData);
    }
  }, [editData]);

  const currentSelectedItem = items.find((item) => item.id === currentItem.current);

  return (
    <Fragment>
      <>
        <Box
          sx={{
            backgroundColor: "#FFF",
          }}>
          {galleryDialogOpen && (
            <DamContentGallery
              handleImageSelected={handleSelectedImage}
              toggleGallery={toggleGallery}
              assetType={"Image"}
              processing={false}
              dialogOpen={galleryDialogOpen}
              isCrop={isCrop}
            />
          )}
        </Box>
        <Options
          showGallery={showGallery}
          items={items}
          setItems={setItems}
          changeCrop={changeCrop}
          variant={variant}
          validations={validations}
          placeholder={placeholder}
        />
      </>
      {manualCropShow && (
        <ManualCropUsingCdn
          open={manualCropShow}
          isCrop={isCrop}
          backTo={backTo}
          doneCropCompleted={doneCropCompleted}
          originalImage={currentSelectedItem?.image?.original_image}
          published_images={currentSelectedItem?.image?.published_images}
        />
      )}
    </Fragment>
  );
};

export default memo(XImageRenderWithText);
